import React from "react";
import { privacy } from "./PrivacyPolicy";

const Privacy = () => {
    return <div style={{margin: "10%"}} dangerouslySetInnerHTML={{ __html: privacy }} />;
};

export default Privacy;
